import { useMemo } from 'react';
import getCurrentWeek from '../helpers/getCurrentWeek';

export default function useCurrentWeek(currentWeek?: Date | string) {
    return useMemo(() => getCurrentWeek(currentWeek), [currentWeek]);
}
